(() => {
  if (customElements.get('t2m-sim-coverage')) return;
  class SimCoverage extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.initialize());
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.removeEventListener('input', this.onInput);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      this.initialized = false;
    }
    initialize() {
      if (this.initialized || !this.isConnected) return;
      const source = this.querySelector('[data-coverage-data]');
      const labels = this.querySelector('[data-coverage-labels]');
      if (!source || !labels) return;
      try {
        this.data = JSON.parse(source.textContent);
        this.labels = JSON.parse(labels.textContent);
      } catch { return; }
      this.search = this.querySelector('[data-coverage-search]');
      this.plan = this.querySelector('[data-coverage-plan]');
      this.results = this.querySelector('[data-coverage-results]');
      this.status = this.querySelector('[data-coverage-status]');
      this.more = this.querySelector('[data-coverage-more]');
      if (!this.search || !this.plan || !this.results || !this.status || !this.more) return;
      this.limit = 6;
      this.onInput = (event) => {
        if (event.target !== this.search) return;
        this.limit = 6;
        this.render();
      };
      this.onChange = (event) => {
        if (event.target !== this.plan && event.target !== this.search) return;
        this.limit = 6;
        this.render();
      };
      this.onClick = (event) => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-coverage-query')) {
          this.search.value = button.dataset.coverageQuery;
          this.limit = 6;
          this.render();
        } else if (button.hasAttribute('data-coverage-clear')) {
          this.search.value = '';
          this.plan.value = 'all';
          this.limit = 6;
          this.render();
          this.search.focus();
        } else if (button === this.more) {
          const next = this.limit;
          this.limit += 6;
          this.render();
          this.results.children[next]?.querySelector('h4')?.focus();
        }
      };
      this.addEventListener('input', this.onInput);
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.initialized = true;
      this.querySelector('[data-coverage-tools]').hidden = false;
      this.render();
    }
    normalize(value) {
      return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    }
    matches(country, query) {
      if (!query) return true;
      if (['uk', 'u k', 'united kingdom', 'great britain', 'britain'].includes(query)) return /\(UK\)/i.test(country.name);
      if (['us', 'u s', 'usa', 'u s a', 'united states of america'].includes(query)) query = 'united states';
      const name = this.normalize(country.name);
      return query.split(' ').every(word => name.includes(word));
    }
    element(tag, className, text) {
      const el = document.createElement(tag);
      if (className) el.className = className;
      if (text !== undefined) el.textContent = text;
      return el;
    }
    render() {
      const query = this.normalize(this.search.value);
      const selected = this.plan.value === 'all' ? null : Number(this.plan.value);
      this.results.replaceChildren();
      this.more.hidden = true;
      if (!query && selected === null) {
        this.status.textContent = this.labels.empty;
        return;
      }
      const matches = this.data.countries.filter(country =>
        this.matches(country, query) && (selected === null || country.included[selected] === true)
      );
      if (!matches.length) {
        this.status.textContent = this.labels.noResults;
        return;
      }
      const shown = matches.slice(0, this.limit);
      this.status.textContent = this.labels.showing.replace('__SHOWN__', String(shown.length)).replace('__TOTAL__', String(matches.length));
      const fragment = document.createDocumentFragment();
      for (const country of shown) {
        const card = this.element('article', 't2m-coverage__country');
        const title = this.element('h4', '', country.name);
        title.tabIndex = -1;
        card.append(title);
        const list = this.element('dl', 't2m-coverage__plan-statuses');
        this.labels.plans.forEach((plan, index) => {
          const included = country.included[index] === true;
          const group = this.element('div', 't2m-coverage__plan-status' + (selected === index ? ' is-selected' : ''));
          group.append(this.element('dt', '', plan));
          const value = this.element('dd', included ? 'is-covered' : 'is-not-covered');
          const icon = this.element('span', '', included ? '✓' : '—');
          icon.setAttribute('aria-hidden', 'true');
          value.append(icon, document.createTextNode(' ' + (included ? this.labels.included : this.labels.notIncluded)));
          group.append(value);
          list.append(group);
        });
        card.append(list);
        if (/\*|restriction/i.test(country.name)) card.append(this.element('p', 't2m-coverage__restriction', this.labels.restriction));
        fragment.append(card);
      }
      this.results.append(fragment);
      this.more.hidden = matches.length <= this.limit;
    }
  }
  customElements.define('t2m-sim-coverage', SimCoverage);
})();
